module.exports = __webpack_public_path__ + "img/teacher2.ca3fa516.webp";